// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'BerlingskeSerif', 'BerlingskeSerif Fallback', Georgia, Times New Roman, Times, sans-serif, serif"},"className":"__className_1f1eb3"};